import React, { useState, useEffect, useRef } from 'react';
import BillingAutomationHeader from './BillingAutomationHeader';
import back_arrow from "../../assets/svg/back-arrow.svg";
import schedule_icon from "../../assets/svg/schedule_icon.svg";
import "../../styles/BillingAutomation/BillingAutomationCreation.css";
import { FiPlus } from "react-icons/fi";
import { MdOutlineWorkOutline } from "react-icons/md";
import { TbFileInvoice, TbReceipt, TbCalendar } from "react-icons/tb";
import delete_icon from "../../assets/svg/delete_icon.svg";
import repeat_stroke_rounded from "../../assets/svg/repeat_stroke_rounded.svg";
import AsyncSelect from "react-select/async";
import axiosInstance from "../../axiosInstance";
import CommonFooter from '../../CommonFooter/CommonFooter';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import BillingAutomationMergedCharges from './Billingautomationmergedcharges.js';
import edit_icon from "../../assets/svg/combined_charges_edit.svg";
import SapCsvSafeInput from "../../CommonRemarksRestriction/SapCsvSafeInput";

const INVOICE_TYPE_OPTIONS = [
  { value: 'single_invoice', label: 'Single Invoice' },
  { value: 'separate_invoice', label: 'Separate Invoice' },
  { value: 'merged_single_invoice', label: 'Merged & Single Invoice' },
  { value: 'merged_separate_invoice', label: 'Merged & Separate Invoice' },
];

// Helper function to get ordinal suffix (1st, 2nd, 3rd, etc.)
const getOrdinalSuffix = (day) => {
  const d = Number(day);
  if (d >= 11 && d <= 13) return 'th';
  const lastDigit = d % 10;
  if (lastDigit === 1) return 'st';
  if (lastDigit === 2) return 'nd';
  if (lastDigit === 3) return 'rd';
  return 'th';
};

// Helper function to format schedule display
const getReadableSchedule = (schedule) => {
  if (!schedule) return "";

  if (schedule.periodType === 'weekly') {
    return `Every ${Number(schedule.weeklyInterval) || 1} week(s) on ${schedule.weeklyDay}`;
  } else {
    const interval = Number(schedule.monthlyInterval) || 1;
    const day = Number(schedule.monthlyDay) || 1;

    if (interval === 1) {
      return `Monthly on ${day}${getOrdinalSuffix(day)}`;
    } else {
      return `Once every ${interval} months on ${day}${getOrdinalSuffix(day)}`;
    }
  }
};

const PeriodPopup = ({ onClose, onSave, contractStartDate, contractEndDate, schedule }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('weekly');
  const [activeDay, setActiveDay] = useState('Monday');
  const [weeklyInterval, setWeeklyInterval] = useState(1);
  const [monthlyDay, setMonthlyDay] = useState(1);
  const [monthlyInterval, setMonthlyInterval] = useState(1);

  const weekDays = [
    { label: 'S', value: 'Sunday' }, { label: 'M', value: 'Monday' },
    { label: 'T', value: 'Tuesday' }, { label: 'W', value: 'Wednesday' },
    { label: 'T', value: 'Thursday' }, { label: 'F', value: 'Friday' },
    { label: 'S', value: 'Saturday' },
  ];

  // Initialize popup state from existing schedule in edit mode
  useEffect(() => {
    if (schedule) {
      if (schedule.periodType === 'weekly') {
        setSelectedPeriod('weekly');
        setWeeklyInterval(Number(schedule.weeklyInterval) || 1);
        const DAY_FULL = {
          Sun: 'Sunday', Mon: 'Monday', Tue: 'Tuesday',
          Wed: 'Wednesday', Thu: 'Thursday', Fri: 'Friday', Sat: 'Saturday',
        };
        setActiveDay(DAY_FULL[schedule.weeklyDay] || schedule.weeklyDay || 'Monday');
      } else if (schedule.periodType === 'monthly') {
        setSelectedPeriod('monthly');
        setMonthlyDay(Number(schedule.monthlyDay) || 1);
        setMonthlyInterval(Number(schedule.monthlyInterval) || 1);
      }
    }
  }, [schedule]);

  // const getNextTriggerDate = () => {
  //   const startDate = triggerStartDate ? new Date(triggerStartDate) : new Date();
  //   const endDate = triggerEndDate ? new Date(triggerEndDate) : new Date('9999-12-31');
  //   const today = new Date();
  //   if (today > endDate) return '';

  //   if (selectedPeriod === 'weekly') {
  //     const targetDay = weekDays.findIndex(d => d.value === activeDay);
  //     const diff = (targetDay + 7 - startDate.getDay()) % 7;
  //     const nextDate = new Date(startDate);
  //     nextDate.setDate(startDate.getDate() + diff + weeklyInterval * 7);
  //     return nextDate <= endDate ? nextDate.toDateString() : '';
  //   }
  //   if (selectedPeriod === 'monthly') {
  //     const nextDate = new Date(startDate);
  //     nextDate.setDate(parseInt(monthlyDay) || 1);
  //     if (parseInt(monthlyInterval) > 0) nextDate.setMonth(nextDate.getMonth() + parseInt(monthlyInterval));
  //     return nextDate <= endDate ? nextDate.toDateString() : '';
  //   }
  //   return '';
  // };

  const DAY_ABBREV = {
    Sunday: 'Sun', Monday: 'Mon', Tuesday: 'Tue',
    Wednesday: 'Wed', Thursday: 'Thu', Friday: 'Fri', Saturday: 'Sat',
  };

  const handleSave = () => {
    const schedule = {
      periodType: selectedPeriod,
      ...(selectedPeriod === 'weekly'
        ? { weeklyInterval: Number(weeklyInterval), weeklyDay: DAY_ABBREV[activeDay] ?? activeDay }
        : { monthlyInterval: Number(monthlyInterval), monthlyDay: Number(monthlyDay) }),
    };
    onSave(schedule);
  };

  return (
    <div className="creation-popup-overlay">
      <div className="creation-popup-box">
        <div className="creation-popup-header">
          <p className="popup-title">Set Time Period</p>
          <p className="popup-close" onClick={onClose}>×</p>
        </div>

        <div className="creation-popup-content">
          <label className={`option-btn ${selectedPeriod === 'weekly' ? 'active' : ''}`}>
            <input type="radio" name="period" checked={selectedPeriod === 'weekly'} onChange={() => setSelectedPeriod('weekly')} />
            Weekly
          </label>
          <label className={`option-btn ${selectedPeriod === 'monthly' ? 'active' : ''}`}>
            <input type="radio" name="period" checked={selectedPeriod === 'monthly'} onChange={() => setSelectedPeriod('monthly')} />
            Monthly
          </label>
        </div>

        {selectedPeriod === 'weekly' && (
          <>
            <div className="creation-popup-text">
              <span>
                Every
                <input type="number" min={1} value={weeklyInterval}
                  onChange={e => setWeeklyInterval(Number(e.target.value))}
                  className="one-week" style={{ textAlign: 'center' }} />
                week(s) once
              </span>
            </div>
            <div className="creation-popup-days">
              {weekDays.map((day, i) => (
                <button key={i} onClick={() => setActiveDay(day.value)}
                  className={`round-circle-days ${activeDay === day.value ? 'active' : ''}`}>
                  {day.label}
                </button>
              ))}
            </div>
          </>
        )}

        {selectedPeriod === 'monthly' && (
          <div className="creation-popup-monthly-wrapper">
            <div className="creation-popup-monthly">
              <label className="monthly-option-row">
                <span>
                  On the{' '}
                  <input type="number" min={1} max={31} value={monthlyDay}
                    onChange={e => setMonthlyDay(Number(e.target.value))}
                    className="monthly-only-btn" />
                  day,&nbsp;every&nbsp;
                  <select value={monthlyInterval} onChange={e => setMonthlyInterval(Number(e.target.value))} className="monthly-dropdown">
                    {[...Array(12)].map((_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
                  </select>
                  {monthlyInterval > 1 ? ' months' : ' month'}
                </span>
              </label>
            </div>
          </div>
        )}

        <div className="creation-popup-everyweek">
          <span>
            <img src={repeat_stroke_rounded} alt="" style={{ marginRight: '8px' }} />
            {selectedPeriod === 'weekly' && `Every ${weeklyInterval} week(s) on ${activeDay}`}
            {selectedPeriod === 'monthly' && (() => {
              return monthlyInterval === 1
                ? `Monthly on ${monthlyDay}${getOrdinalSuffix(monthlyDay)}`
                : `Once every ${monthlyInterval} months on ${monthlyDay}${getOrdinalSuffix(monthlyDay)}`;
            })()}
          </span>
        </div>

        <div style={{
          padding: '10px 14px',
          backgroundColor: '#FFF8E1',
          borderLeft: '3px solid #F59E0B',
          borderRadius: '6px',
          fontSize: '12px',
          color: '#92400E',
          lineHeight: '1.6',
        }}>
          <strong>Note:</strong> Invoices will be generated only within the contract's active period.
          Triggers beyond the <strong>expiry date</strong> will not be processed.
        </div>

        {/* <div className="creation-popup-trigger-range">
          <label style={{ fontWeight: '600', fontSize: '0.92rem', marginBottom: '6px', display: 'block' }}>
            Active date range:-
          </label>
          <div className="trigger-date-inputs" style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={{ fontSize: '0.85rem' }}>Start Date</label>
              <input type="date" value={triggerStartDate} onChange={e => setTriggerStartDate(e.target.value)}
                className="date-picker"
                style={{ padding: '8px 12px', borderRadius: '10px', fontSize: '0.9rem', border: '1px solid #ccc', minWidth: '160px', fontFamily: 'Work Sans' }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={{ fontSize: '0.85rem' }}>End Date</label>
              <input type="date" value={triggerEndDate} onChange={e => setTriggerEndDate(e.target.value)}
                className="date-picker"
                style={{ padding: '8px 12px', borderRadius: '10px', fontSize: '0.9rem', border: '1px solid #ccc', minWidth: '160px', fontFamily: 'Work Sans' }} />
            </div>
          </div>
        </div>

        <div className="creation-popup-trigger-date">
          <span style={{ fontSize: '0.9rem', color: '#666', marginTop: '4px', display: 'inline-block' }}>
            Next Job will create on <strong>{getNextTriggerDate()}</strong>
          </span>
        </div> */}

        <div className="creation-popup-button">
          <button className="creation-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="creation-save-btn" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

const InvoiceTable = ({ lines, bg = '#fff', onDeleteLine }) => (
  <table className="invoice_table" style={{ width: '100%' }}>
    <thead>
      <tr>
        <th colSpan={onDeleteLine ? 9 : 8} style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
      </tr>
      <tr>
        {['CHARGE CODE', 'DESCRIPTION', 'PO NUMBER', 'PO DATE', 'REMARKS', 'QUANTITY', 'RATE', 'NET TOTAL'].map(h => (
          <th key={h} style={{ backgroundColor: '#D9FFE2' }}>{h}</th>
        ))}
        {onDeleteLine && <th style={{ backgroundColor: '#D9FFE2', width: '40px' }}></th>}
      </tr>
    </thead>
    <tbody>
      {lines.map((line, i) => (
        <tr key={i}>
          <td style={{ padding: '10px', backgroundColor: bg }}>{line.charge_code}</td>
          <td style={{ backgroundColor: bg }}>{line.charge_name}</td>
          <td style={{ backgroundColor: bg }}>{line.po_wo_number || '--'}</td>
          <td style={{ backgroundColor: bg }}>{line.po_wo_date || '--'}</td>
          <td style={{ backgroundColor: bg }}>{line.remarks || '--:--'}</td>
          <td style={{ backgroundColor: bg }}>{line.unit_of_quantity}</td>
          <td style={{ backgroundColor: bg }}>{line.unit_of_rate}</td>
          <td style={{ backgroundColor: bg }}>{line.net_total}</td>
          {onDeleteLine && (
            <td style={{ backgroundColor: bg, textAlign: 'center' }}>
              <img
                src={delete_icon}
                alt="Delete"
                style={{ width: '25px', height: '25px', cursor: 'pointer' }}
                onClick={() => onDeleteLine(line.id)}
              />
            </td>
          )}
        </tr>
      ))}
    </tbody>
  </table>
);

const InvoiceFooter = () => (
  <div className="invoice-footer-info" style={{ padding: '10px 12px' }}>
    <div className="invoice-footer-row">
      <span className="invoice-footer-label">Supply Period</span>
      <span className="invoice-footer-value">#supply_period</span>
    </div>
    <div className="invoice-footer-row">
      <span className="invoice-footer-label">Remarks</span>
      <span className="invoice-footer-value">This is an auto generated #remarks for the month #supply_period</span>
    </div>
  </div>
);

const SingleInvoiceCard = ({ card, onDelete, onSetPeriod, schedule, onDeleteLine, billingNature, onBillingNatureChange, remarks, onRemarksChange }) => (
  <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
    <div className="invoice_popup_outercategory" style={{ backgroundColor: '#ffffff' }}>
      <div className="invoice_popup_category_header">
        <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className="category_name" style={{ fontSize: '14px' }}>Single Invoice</span>
          <img src={schedule_icon} alt="Schedule Icon" onClick={onSetPeriod} style={{ height: '19px', width: '19px', cursor: 'pointer' }} />
          {schedule && (
            <span style={{ fontSize: '12px', color: '#6B7280', fontStyle: 'italic' }}>
              {getReadableSchedule(schedule)}
            </span>
          )}

        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', flexWrap: 'wrap' }}>
          <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '8px', height: '30px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <span style={{ color: 'green', fontWeight: '600' }}>SALES : </span>
            <span style={{ color: '#000' }}>Net Total : ₹ {card.lines.reduce((s, l) => s + parseFloat(l.net_total || 0), 0).toLocaleString()}</span>
          </div>
          <div style={{
            width: "1px",
            backgroundColor: "#ccc",
            alignSelf: "stretch",
            flexShrink: 0
          }} />
          <img src={delete_icon} style={{ width: '30px', height: '30px', cursor: 'pointer' }} alt="Delete" onClick={onDelete} />
        </div>
      </div>
      <div className="invoice_popup_category_subheader">
        <div className="invoice_popup_element_list" style={{ overflowX: 'auto', backgroundColor: '#FFEEEE' }}>
          <div className="table-container">
            <InvoiceTable lines={card.lines} bg="#fff" onDeleteLine={onDeleteLine} />
          </div>
          {/* <InvoiceFooter /> */}
          <CardBillingFields
            cardId={card.id}
            billingNature={billingNature}
            onBillingNatureChange={onBillingNatureChange}
            remarks={remarks}
            onRemarksChange={onRemarksChange}
          />
        </div>
      </div>
    </div>
  </div>
);

const SeparateInvoiceCard = ({ card, onDelete, onSetPeriod, schedule, onDeleteLine, billingNature, onBillingNatureChange, remarks, onRemarksChange }) => (
  <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
    <div className="invoice_popup_outercategory" style={{ backgroundColor: '#ffffff' }}>
      <div className="invoice_popup_category_header">
        <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className="category_name" style={{ fontSize: '14px' }}>Separate Invoice</span>
          <img src={schedule_icon} alt="Schedule Icon" onClick={onSetPeriod} style={{ height: '19px', width: '19px', cursor: 'pointer' }} />
          {schedule && (
            <span style={{ fontSize: '12px', color: '#6B7280', fontStyle: 'italic' }}>
              {getReadableSchedule(schedule)}
            </span>
          )}

        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', flexWrap: 'wrap' }}>
          <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '8px', height: '30px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <span style={{ color: 'green', fontWeight: '600' }}>SALES : </span>
            <span style={{ color: '#000' }}>Net Total : ₹ {card.lines.reduce((s, l) => s + parseFloat(l.net_total || 0), 0).toLocaleString()}</span>
          </div>
          <div style={{
            width: "1px",
            backgroundColor: "#ccc",
            alignSelf: "stretch",
            flexShrink: 0
          }} />
          <img src={delete_icon} style={{ width: '30px', height: '30px', cursor: 'pointer' }} alt="Delete" onClick={onDelete} />
        </div>
      </div>
      <div className="invoice_popup_category_subheader">
        {card.lines.map((line, i) => (
          <div key={i} className="invoice_popup_element_list" style={{ overflowX: 'auto', backgroundColor: '#E3EBFF', marginBottom: i < card.lines.length - 1 ? '10px' : '0' }}>
            <div className="table-container">
              <InvoiceTable lines={[line]} bg="#fff" onDeleteLine={onDeleteLine} />
            </div>
            <CardBillingFields
              billingNature={billingNature?.[line.id] || ''}
              onBillingNatureChange={(val) => onBillingNatureChange(line.id, val)}
              remarks={remarks?.[line.id] || ''}
              onRemarksChange={(val) => onRemarksChange(line.id, val)}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

const MergedSingleInvoiceCard = ({ card, onDelete, onSetPeriod, schedule, onDeleteLine, onEdit, billingNature, onBillingNatureChange, remarks, onRemarksChange }) => (
  <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
    <div className="invoice_popup_outercategory" style={{ backgroundColor: '#ffffff' }}>
      <div className="invoice_popup_category_header">
        <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className="category_name" style={{ fontSize: '14px' }}>Merged &amp; Single Invoice</span>
          <img src={schedule_icon} alt="Schedule Icon" onClick={onSetPeriod} style={{ height: '19px', width: '19px', cursor: 'pointer' }} />
          {schedule && (
            <span style={{ fontSize: '12px', color: '#6B7280', fontStyle: 'italic' }}>
              {getReadableSchedule(schedule)}
            </span>
          )}

        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', flexWrap: 'wrap' }}>
          <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '8px', height: '30px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <span style={{ color: 'green', fontWeight: '600' }}>SALES : </span>
            <span style={{ color: '#000' }}>Net Total : ₹ {card.lines.reduce((s, l) => s + parseFloat(l.net_total || 0), 0).toLocaleString()}</span>
          </div>
          <div style={{
            width: "1px",
            backgroundColor: "#ccc",
            alignSelf: "stretch",
            flexShrink: 0
          }} />
          <div onClick={onEdit}
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              border: '1px solid #E5E7EB',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              background: '#fff'
            }}
          >
            <img src={edit_icon} alt="edit" style={{ width: '18px', height: '18px' }} />
          </div>
          <div style={{
            width: "1px",
            backgroundColor: "#ccc",
            alignSelf: "stretch",
            flexShrink: 0
          }} />
          <img src={delete_icon} style={{ width: '30px', height: '30px', cursor: 'pointer' }} alt="Delete" onClick={onDelete} />
        </div>
      </div>
      <div className="invoice_popup_category_subheader">
        <div className="invoice_popup_element_list" style={{ overflowX: 'auto', backgroundColor: '#E8F5E9' }}>
          <div className="table-container">
            <InvoiceTable lines={card.lines} bg="#fff" onDeleteLine={onDeleteLine} />
          </div>
          {/* <InvoiceFooter /> */}
          <CardBillingFields
            billingNature={billingNature || ''}
            onBillingNatureChange={onBillingNatureChange}
            remarks={remarks || ''}
            onRemarksChange={onRemarksChange}
          />
        </div>
      </div>
    </div>
  </div>
);

const MergedSeparateInvoiceCard = ({ card, onDelete, onSetPeriod, schedule, onDeleteLine, onEdit, billingNature, onBillingNatureChange, remarks, onRemarksChange }) => {
  const groups = card.lines.reduce((acc, line) => {
    const key = line.line_group_no ?? line.id;
    if (!acc[key]) acc[key] = { jobTypeName: line.job_type_name || key, lines: [] };
    acc[key].lines.push(line);
    return acc;
  }, {});

  const groupEntries = Object.entries(groups);

  return (
    <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
      <div className="invoice_popup_outercategory" style={{ backgroundColor: '#ffffff' }}>
        <div className="invoice_popup_category_header">
          <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="category_name" style={{ fontSize: '14px' }}>Merged &amp; Separate Invoice</span>
            <img src={schedule_icon} alt="Schedule Icon" onClick={onSetPeriod} style={{ height: '19px', width: '19px', cursor: 'pointer' }} />
            {schedule && (
              <span style={{ fontSize: '12px', color: '#6B7280', fontStyle: 'italic' }}>
                {getReadableSchedule(schedule)}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', flexWrap: 'wrap' }}>
            <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '8px', height: '30px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <span style={{ color: 'green', fontWeight: '600' }}>SALES : </span>
              <span style={{ color: '#000' }}>Net Total : ₹ {card.lines.reduce((s, l) => s + parseFloat(l.net_total || 0), 0).toLocaleString()}</span>
            </div>
            <div style={{
              width: "1px",
              backgroundColor: "#ccc",
              alignSelf: "stretch",
              flexShrink: 0
            }} />
            <div onClick={onEdit}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                border: '1px solid #E5E7EB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                background: '#fff'
              }}
            >
              <img
                src={edit_icon}
                alt="edit"
                style={{
                  width: '18px',
                  height: '18px'
                }}
              />
            </div>

            <div style={{
              width: "1px",
              backgroundColor: "#ccc",
              alignSelf: "stretch",
              flexShrink: 0
            }} />
            <img src={delete_icon} style={{ width: '30px', height: '30px', cursor: 'pointer' }} alt="Delete" onClick={onDelete} />
          </div>
        </div>
        <div className="invoice_popup_category_subheader">
          {groupEntries.map(([groupKey, group], gi) => (
            <div key={gi} style={{ marginBottom: gi < groupEntries.length - 1 ? '10px' : '0' }}>
              <div className="invoice_popup_element_list" style={{ overflowX: 'auto', backgroundColor: '#FFF8E1' }}>
                <div className="table-container">
                  <InvoiceTable lines={group.lines} bg="#fff" onDeleteLine={onDeleteLine} />
                </div>
                <CardBillingFields
                  billingNature={billingNature?.[groupKey] || ''}
                  onBillingNatureChange={(val) => onBillingNatureChange(groupKey, val)}
                  remarks={remarks?.[groupKey] || ''}
                  onRemarksChange={(val) => onRemarksChange(groupKey, val)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const REMARKS_PILLS = [
  { label: '#supply_period', value: '#supply_period' },
];

const CardBillingFields = ({ billingNature, onBillingNatureChange, remarks, onRemarksChange }) => {

  const remarksInputRef = useRef(null);

  const handlePillClick = (pillValue) => {
    const input = remarksInputRef.current;
    const currentValue = remarks || '';

    if (input) {
      const start = input.selectionStart ?? currentValue.length;
      const end = input.selectionEnd ?? currentValue.length;
      const newValue = currentValue.slice(0, start) + pillValue + currentValue.slice(end);
      if (newValue.length <= 255) {
        onRemarksChange(newValue);
        setTimeout(() => {
          input.focus();
          const newCursor = start + pillValue.length;
          input.setSelectionRange(newCursor, newCursor);
        }, 0);
      }
    } else {
      const newValue = (currentValue + pillValue).slice(0, 255);
      onRemarksChange(newValue);
    }
  };

  return (

    <div style={{ padding: '10px 12px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start', borderTop: '1px solid #E5E7EB' }}>

      <div style={{ flex: '1 1 45%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '6px' }}>
          <label style={{ fontSize: '14px', fontWeight: 600, fontFamily: 'Work Sans', color: '#19324C', margin: 0 }}>
            Remarks
          </label>
          {REMARKS_PILLS.map((pill) => (
            <span
              key={pill.value}
              onClick={() => handlePillClick(pill.value)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '2px 10px',
                borderRadius: '20px',
                backgroundColor: '#EEF2FF',
                color: '#4338CA',
                fontSize: '11px',
                fontWeight: 600,
                fontFamily: 'Work Sans',
                cursor: 'pointer',
                border: '1px solid #C7D2FE',
                userSelect: 'none',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#E0E7FF'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#EEF2FF'}
            >
              {pill.label}
            </span>
          ))}

          {REMARKS_PILLS.length > 0 && (
            <>
              <span style={{
                fontSize: '11px',
                color: '#9CA3AF',
                fontFamily: 'Work Sans',
              }}>
                ←
              </span>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px',
                padding: '2px 8px',
                borderRadius: '20px',
                backgroundColor: '#EFF6FF',
                border: '1px solid #BFDBFE',
                fontSize: '11px',
                color: '#3B82F6',
                fontFamily: 'Work Sans',
                userSelect: 'none',
              }}>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                  backgroundColor: '#BFDBFE',
                  color: '#1D4ED8',
                  fontSize: '9px',
                  fontWeight: 700,
                  fontStyle: 'normal',
                  flexShrink: 0,
                }}>
                  i
                </span>
                Click to insert at cursor
              </span>
            </>
          )}
        </div>
        <SapCsvSafeInput
          value={remarks || ''}
          onChange={onRemarksChange}
          maxLength={255}
          placeholder="Enter Remarks..."
          inputRef={remarksInputRef}
          style={{
            width: '100%',
            height: '35px',
            padding: '6px 8px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            fontSize: '13px',
            fontFamily: 'Work Sans',
            boxSizing: 'border-box',
          }}
        />
        <p style={{ fontSize: '11px', textAlign: 'right', color: '#777', margin: '2px 0 0' }}>
          {(remarks || '').length}/255
        </p>
      </div>

      {/* Billing Nature */}
      <div style={{ flex: '1 1 45%' }}>
        <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, fontFamily: 'Work Sans', color: '#19324C' }}>
          Billing Nature
        </label>
        <SapCsvSafeInput
          value={billingNature || ''}
          onChange={onBillingNatureChange}
          maxLength={18}
          placeholder="Enter Billing Nature"
          style={{
            width: '100%',
            height: '35px',
            padding: '6px 8px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            fontSize: '13px',
            fontFamily: 'Work Sans',
            margin: '0px',
            boxSizing: 'border-box',
          }}
        />
        <p style={{ fontSize: '11px', textAlign: 'right', color: '#777', margin: '2px 0 0' }}>
          {(billingNature || '').length}/18
        </p>
      </div>

    </div>
  )
};

const BillingAutomationCreation = () => {
  const [contractCode, setContractCode] = useState(null);
  const [invoiceType, setInvoiceType] = useState('');
  const [jobType, setJobType] = useState([]);
  const [contractDetails, setContractDetails] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [jobTypeOptions, setJobTypeOptions] = useState([]);
  const jobDropdownRef = useRef(null);
  const navigate = useNavigate();
  const [checkedLines, setCheckedLines] = useState({});
  const [invoiceCards, setInvoiceCards] = useState([]);
  const [periodPopupCardId, setPeriodPopupCardId] = useState(null);
  const [cardSchedules, setCardSchedules] = useState({});
  const [removedLineIds, setRemovedLineIds] = useState(new Set());
  const [project, setProject] = useState(null);

  const [editingCardId, setEditingCardId] = useState(null);
  const [mergedPopupOpen, setMergedPopupOpen] = useState(false);
  const [mergedPopupLines, setMergedPopupLines] = useState([]);
  const [mergedPopupInvoiceType, setMergedPopupInvoiceType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const editId = location.state?.id || null;
  const isEdit = location.state?.mode === 'edit';

  const [deleteLineIds, setDeleteLineIds] = useState([])

  const [cardBillingNature, setCardBillingNature] = useState({});
  const [cardRemarks, setCardRemarks] = useState({});

  useEffect(() => {
    if (!isEdit || !editId) return;

    const loadEditData = async () => {
      setIsLoadingDetails(true);
      try {
        const res = await axiosInstance.get(`/automation/edit/${editId}`);
        const { automation, job_types } = res.data?.data || {};
        if (!automation) return;

        setContractCode({
          label: automation.contract_code,
          value: automation.contract_id,
        });

        setProject({
          label:
            `${automation.project_code} - ${automation.project_name}`,
          value: automation.project_id,
        });

        setContractDetails({
          contract: {
            project_id: automation.project_id,
            project_code: automation.project_code,
            project_name: automation.project_name,
            contract_start_date: automation.start_date,
            contract_expiry_date: automation.end_date,
            contract_mail: automation.contract_mail || '',
          },
          job_types: job_types.map(jt => ({
            job_type_id: jt.job_type_id,
            job_type_name: jt.job_type_name,
            sales_total: jt.net_total,
            sales_lines: jt.charge_lines.map(cl => ({
              id: cl.contract_charge_sales_line_id,
              charge_code: cl.charge_code,
              charge_name: cl.description,
              po_wo_number: cl.po_wo_number,
              po_wo_date: cl.po_wo_date,
              remarks: cl.remarks,
              unit_of_quantity: cl.unit_of_quantity,
              unit_of_rate: cl.unit_of_rate,
              net_total: cl.net_total,
              job_type_id: cl.job_type_id,
              // carry edit-only fields through so submit can use them
              automation_line_id: cl.automation_line_id,
              sap_id: cl.card_configs?.[0]?.sap_id ?? null,
              sap_code: cl.card_configs?.[0]?.sap_code ?? null,
              sap_description: cl.card_configs?.[0]?.sap_description,
            })),
          })),
        });

        // 3. Restore job type pills
        const uniqueJobTypes = job_types.map(jt => ({
          label: jt.job_type_name,
          value: jt.job_type_id,
        }));
        setJobType(uniqueJobTypes);

        // 4. Rebuild invoice cards from mapped lines
        const TYPE_REVERSE_MAP = {
          single: 'single_invoice',
          separate: 'separate_invoice',
          merge_single: 'merged_single_invoice',
          merge_separate: 'merged_separate_invoice',
        };

        const PERIOD_REVERSE = (period) => {
          if (!period) return null;
          if (period.period_type === 'weekly') {
            const DAY_FULL = {
              Sun: 'Sunday', Mon: 'Monday', Tue: 'Tuesday',
              Wed: 'Wednesday', Thu: 'Thursday', Fri: 'Friday', Sat: 'Saturday',
            };
            return {
              periodType: 'weekly',
              weeklyInterval: period.week_once,
              weeklyDay: DAY_FULL[period.week_days] ?? period.week_days,
              // triggerStartDate: period.week_start_date,
              // triggerEndDate: period.week_end_date,
            };
          } else {
            return {
              periodType: 'monthly',
              monthlyDay: period.month_date,
              monthlyInterval: period.month_period,
              // triggerStartDate: period.month_start_date,
              // triggerEndDate: period.month_end_date,
            };
          }
        };

        // Group mapped lines into cards
        // Key: invoiceType + (groupNo for merge types, else lineId for separate)
        const cardMap = {};    // cardKey → { type, groupNo, sapCode, lines[] }
        const scheduleMap = {};

        job_types.forEach(jt => {
          jt.charge_lines.forEach(cl => {
            if (!cl.is_mapped || !cl.card_configs?.length) return;

            cl.card_configs.forEach(config => {
              const frontendType = TYPE_REVERSE_MAP[config.invoice_type];
              let cardKey;

              if (config.invoice_type === 'single') {
                cardKey = `single_${config.invoice_group_no ?? cl.contract_charge_sales_line_id}`;
              } else if (config.invoice_type === 'separate') {
                cardKey = `separate_${cl.contract_charge_sales_line_id}`;
              } else {
                cardKey = `${config.invoice_type}_${config.invoice_group_no}`;
              }

              if (!cardMap[cardKey]) {
                cardMap[cardKey] = {
                  type: frontendType,
                  lines: [],
                  period: config.period,
                  sapCode: config.sap_code,
                  billing_nature: config.billing_nature || '',
                  remarks: config.remarks || '',
                };
              }

              cardMap[cardKey].lines.push({
                id: cl.contract_charge_sales_line_id,
                charge_code: cl.charge_code,
                charge_name: cl.description,
                remarks: cl.remarks,
                unit_of_quantity: cl.unit_of_quantity,
                unit_of_rate: cl.unit_of_rate,
                net_total: cl.net_total,
                job_type_id: cl.job_type_id,
                job_type_name: jt.job_type_name,
                automation_line_id: config.automation_line_id,
                sap_id: config.sap_id ?? null,
                sap_code: config.sap_code,
                sap_description: config.sap_description,
                line_group_no: config.line_group_no,
                isMergedCombined: false,
                po_wo_number: cl.po_wo_number,
                po_wo_date: cl.po_wo_date,
                billing_nature: config.billing_nature || '',
                remarks_automation: config.remarks || '',
              });
            });
          });
        });

        const restoredCards = [];
        const restoredSchedules = {};
        const restoredRemoved = new Set();
        const restoredBillingNature = {};
        const restoredRemarks = {};

        Object.entries(cardMap).forEach(([, card]) => {
          const cardId = Date.now() + Math.random(); // unique
          restoredCards.push({ id: cardId, type: card.type, lines: card.lines });
          const schedule = PERIOD_REVERSE(card.period);
          if (schedule) restoredSchedules[cardId] = schedule;
          card.lines.forEach(l => restoredRemoved.add(l.id));

          if (card.type === 'separate_invoice') {
            const bnMap = {};
            const rmMap = {};
            card.lines.forEach(l => {
              if (l.billing_nature) bnMap[l.id] = l.billing_nature;
              if (l.remarks_automation) rmMap[l.id] = l.remarks_automation;
            });
            if (Object.keys(bnMap).length) restoredBillingNature[cardId] = bnMap;
            if (Object.keys(rmMap).length) restoredRemarks[cardId] = rmMap;

          } else if (card.type === 'merged_separate_invoice') {
            const bnMap = {};
            const rmMap = {};
            card.lines.forEach(l => {
              const groupKey = l.line_group_no ?? l.id;
              if (l.billing_nature && !bnMap[groupKey]) bnMap[groupKey] = l.billing_nature;
              if (l.remarks_automation && !rmMap[groupKey]) rmMap[groupKey] = l.remarks_automation;
            });
            if (Object.keys(bnMap).length) restoredBillingNature[cardId] = bnMap;
            if (Object.keys(rmMap).length) restoredRemarks[cardId] = rmMap;

          } else {
            if (card.billing_nature) restoredBillingNature[cardId] = card.billing_nature;
            if (card.remarks) restoredRemarks[cardId] = card.remarks;
          }
        });

        // NEW — after restoredCards is built, collapse combined lines inside merge cards
        const collapsedCards = restoredCards.map(card => {
          if (
            card.type !== 'merged_single_invoice' &&
            card.type !== 'merged_separate_invoice'
          ) {
            return card;
          }

          // Group lines by line_group_no
          const lineGroupMap = {};
          const standaloneLines = [];

          card.lines.forEach(line => {
            const lgn = line.line_group_no;
            if (lgn == null) {
              // Shouldn't happen for merge types, but handle gracefully
              standaloneLines.push({ ...line, isMergedCombined: false });
              return;
            }

            if (!lineGroupMap[lgn]) {
              lineGroupMap[lgn] = [];
            }
            lineGroupMap[lgn].push(line);
          });

          const collapsedLines = [];

          Object.entries(lineGroupMap).forEach(([lgn, rows]) => {
            if (rows.length === 1) {
              // Standalone — not combined with any other row
              collapsedLines.push({ ...rows[0], isMergedCombined: false });
            } else {
              // Multiple rows share same line_group_no → they were combined
              const totalNet = rows.reduce((s, r) => s + parseFloat(r.net_total || 0), 0);
              const totalQty = rows.reduce((s, r) => s + parseFloat(r.unit_of_quantity || 0), 0);
              const rate = totalQty > 0 ? totalNet / totalQty : 0;
              const first = rows[0];

              // Build originalRows — each row needs uniqueId for the MergedCharges popup
              const originalRows = rows.map(r => ({
                ...r,
                uniqueId: `${r.id}_${r.sap_id ?? r.sap_code}_${r.job_type_id}`,
                isChecked: false,
                isCombined: true,
                sap_description: r.sap_description || r.charge_name,
              }));

              collapsedLines.push({
                id: `combined_${first.sap_code}_${lgn}_restored`,
                charge_code: first.charge_code,
                charge_name: first.sap_description || first.charge_name,
                remarks: first.remarks || '--',
                sap_code: first.sap_code,
                sap_id: first.sap_id ?? null,
                po_wo_number: first.po_wo_number || null,  
                po_wo_date: first.po_wo_date || null,
                sap_description: first.sap_description || first.charge_name,
                unit_of_quantity: 1,
                unit_of_rate: parseFloat(rate.toFixed(2)),
                net_total: parseFloat(totalNet.toFixed(2)),
                job_type_id: first.job_type_id,
                job_type_name: first.job_type_name,
                automation_line_id: first.automation_line_id,
                line_group_no: parseInt(lgn),
                isMergedCombined: true,        // ← key flag the MergedCharges popup reads
                originalRows,
              });
            }
          });

          return { ...card, lines: collapsedLines };
        });

        setInvoiceCards(collapsedCards);      // ← use collapsedCards, not restoredCards
        setCardSchedules(restoredSchedules);
        setRemovedLineIds(restoredRemoved);
        setCardBillingNature(restoredBillingNature);
        setCardRemarks(restoredRemarks);

      } catch (err) {
        toast.error('Failed to load automation for editing.');
        console.error(err);
      } finally {
        setIsLoadingDetails(false);
      }
    };

    loadEditData();
  }, [isEdit, editId]);

  const toggleJobDropdown = async () => {
    if (!contractCode) return;
    if (!isJobDropdownOpen && jobTypeOptions.length === 0) {
      const options = await loadJobTypeOptions('');
      setJobTypeOptions(options);
    }
    setIsJobDropdownOpen(prev => !prev);
  };

  const handleJobCheckboxChange = (value) => {
    const exists = jobType.find(j => j.value === value);
    let newSelected;
    if (exists) {
      newSelected = jobType.filter(j => j.value !== value);
    } else {
      const option = jobTypeOptions.find(o => o.value === value);
      newSelected = [...jobType, option];
    }
    setJobType(newSelected);
    fetchContractDetails(newSelected);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (jobDropdownRef.current && !jobDropdownRef.current.contains(e.target)) {
        setIsJobDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const loadContractCodeOptions = async (inputValue) => {
    try {
      if (!project?.value) return [];
      const res = await axiosInstance.get("/contract/get_contractcode", { params: { term: inputValue || '', project_id: project.value } });
      return (res.data?.suggestionlist || []).map(p => ({ label: p.label, value: p.value }));
    } catch { return []; }
  };

  const loadJobTypeOptions = async () => {
    try {
      if (!contractCode?.value) return [];
      const res = await axiosInstance.get(`/automation/contract/jobtypes/${contractCode.value}`);
      return (res.data?.jobtypes || []).map(item => ({ label: item.label, value: item.value }));
    } catch { return []; }
  };

  const loadProjectOptions = async (inputValue) => {
    try {
      const res = await axiosInstance.get(
        "/costsolution/projects/autosuggestion",
        {
          params: {
            term: inputValue || "",
          },
        }
      );

      return (res.data?.autosuggestion || []).map((p) => ({
        label: p.label,
        value: p.value,
      }));
    } catch {
      return [];
    }
  };

  const fetchContractDetails = async (selectedJobTypes) => {
    if (!contractCode?.value || !selectedJobTypes?.length) {
      setContractDetails(null);
      return;
    }
    setIsLoadingDetails(true);
    try {
      const res = await axiosInstance.post('/automation/contract_details', {
        contract_id: contractCode.value,
        job_type_ids: selectedJobTypes.map(j => j.value),
      });
      setContractDetails(res.data?.data || null);
    } catch { setContractDetails(null); }
    finally { setIsLoadingDetails(false); }
  };

  const loadInvoiceTypeOptions = async (inputValue) => {
    return INVOICE_TYPE_OPTIONS.filter(item =>
      item.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const toggleLineCheck = (jobTypeId, lineId) => {
    setCheckedLines(prev => {
      const current = new Set(prev[jobTypeId] || []);
      if (current.has(lineId)) current.delete(lineId);
      else current.add(lineId);
      return { ...prev, [jobTypeId]: current };
    });
  };

  const toggleAllLines = (jobTypeId, lines) => {
    setCheckedLines(prev => {
      const current = prev[jobTypeId] || new Set();
      const availableLines = lines.filter(l => !removedLineIds.has(l.id));
      const allChecked = availableLines.every(l => current.has(l.id));
      const newSet = new Set(allChecked ? [] : availableLines.map(l => l.id));
      return { ...prev, [jobTypeId]: newSet };
    });
  };

  const getAllCheckedLines = () => {
    if (!contractDetails?.job_types) return [];
    const result = [];
    contractDetails.job_types.forEach(jt => {
      const checked = checkedLines[jt.job_type_id] || new Set();
      jt.sales_lines?.forEach(line => {
        if (checked.has(line.id) && !removedLineIds.has(line.id)) {
          result.push({ ...line, job_type_id: jt.job_type_id, job_type_name: jt.job_type_name });
        }
      });
    });
    return result;
  };

  const handleAddInvoice = () => {
    const selectedLines = getAllCheckedLines();
    if (!selectedLines.length) {
      toast.error('Please select at least one line item.');
      return;
    }
    if (!invoiceType) {
      toast.error('Please select an invoice type.');
      return;
    }

    if (invoiceType === 'merged_single_invoice' || invoiceType === 'merged_separate_invoice') {
      setMergedPopupLines(selectedLines);
      setMergedPopupInvoiceType(invoiceType);
      setMergedPopupOpen(true);
      return;
    }

    createInvoiceCard(invoiceType, selectedLines);
  };

  const createInvoiceCard = (type, lines) => {

    const alreadyInCards = new Set(
      invoiceCards.flatMap(c => c.lines.map(l => l.id))
    );

    const dedupedLines = lines.filter(l => !alreadyInCards.has(l.id));

    if (!dedupedLines.length) {
      toast.error('All selected lines are already assigned to a card.');
      return;
    }

    const cardId = Date.now();
    const newCard = { id: cardId, type, lines, lines: dedupedLines };
    setInvoiceCards(prev => [...prev, newCard]);

    const newRemoved = new Set(removedLineIds);
    lines.forEach(l => newRemoved.add(l.id));
    setRemovedLineIds(newRemoved);

    setCheckedLines(prev => {
      const updated = { ...prev };
      Object.keys(updated).forEach(jtId => {
        const newSet = new Set(updated[jtId]);
        lines.forEach(l => newSet.delete(l.id));
        updated[jtId] = newSet;
      });
      return updated;
    });

    // Meaningful toast per type
    if (type === 'single_invoice') {
      toast.success('Single Invoice created successfully!');
    } else if (type === 'separate_invoice') {
      toast.success('Separate Invoice created successfully!');
    } else {
      toast.success('Invoice created successfully!');
    }
  };

  const handleMergedComplete = (finalLines) => {
    if (editingCardId) {
      const editingCard = invoiceCards.find(c => c.id === editingCardId);
      setInvoiceCards(prev =>
        prev.map(card =>
          card.id === editingCardId ? { ...card, lines: finalLines } : card
        )
      );

      // Toast for edit
      if (editingCard?.type === 'merged_single_invoice') {
        toast.success('Merged & Single Invoice updated successfully!');
      } else if (editingCard?.type === 'merged_separate_invoice') {
        toast.success('Merged & Separate Invoice updated successfully!');
      }

      setEditingCardId(null);
      setMergedPopupOpen(false);      // ← was missing
      setMergedPopupLines([]);         // ← was missing
      setMergedPopupInvoiceType('');   // ← was missing

    } else {
      const originalLineIds = mergedPopupLines.map(l => l.id);
      const cardId = Date.now();
      const newCard = { id: cardId, type: mergedPopupInvoiceType, lines: finalLines };
      setInvoiceCards(prev => [...prev, newCard]);

      const newRemoved = new Set(removedLineIds);
      originalLineIds.forEach(id => newRemoved.add(id));
      setRemovedLineIds(newRemoved);

      setCheckedLines(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(jtId => {
          const newSet = new Set(updated[jtId]);
          originalLineIds.forEach(id => newSet.delete(id));
          updated[jtId] = newSet;
        });
        return updated;
      });

      // Toast for create
      if (mergedPopupInvoiceType === 'merged_single_invoice') {
        toast.success('Merged & Single Invoice created successfully!');
      } else if (mergedPopupInvoiceType === 'merged_separate_invoice') {
        toast.success('Merged & Separate Invoice created successfully!');
      }

      setMergedPopupOpen(false);
      setMergedPopupLines([]);
      setMergedPopupInvoiceType('');
    }
  };

  const handleDeleteCard = (cardId) => {
    const card = invoiceCards.find(c => c.id === cardId);
    if (!card) return;

    if (isEdit) {
      const ids = card.lines
        .flatMap(l => (l.isMergedCombined && l.originalRows) ? l.originalRows : [l])
        .map(l => l.automation_line_id)
        .filter(Boolean);
      setDeleteLineIds(prev => [...prev, ...ids]);
    }

    const newRemoved = new Set(removedLineIds);
    card.lines.forEach(l => {
      if (l.isMergedCombined && l.originalRows) {
        l.originalRows.forEach(r => newRemoved.delete(r.id));
      } else {
        newRemoved.delete(l.id);
      }
    });
    setRemovedLineIds(newRemoved);
    setInvoiceCards(prev => prev.filter(c => c.id !== cardId));
    setCardSchedules(prev => { const n = { ...prev }; delete n[cardId]; return n; });
  };

  const handleSavePeriod = (schedule) => {
    setCardSchedules(prev => ({ ...prev, [periodPopupCardId]: schedule }));
    setPeriodPopupCardId(null);
  };

  const handleDeleteCardLine = (cardId, lineId) => {
    if (isEdit) {
      const card = invoiceCards.find(c => c.id === cardId);
      const line = card?.lines.find(l => l.id === lineId);
      if (line?.automation_line_id) {
        setDeleteLineIds(prev => [...prev, line.automation_line_id]);
      }
    }
    setRemovedLineIds(prev => {
      const newSet = new Set(prev);
      newSet.delete(lineId);
      return newSet;
    });
    setInvoiceCards(prev => prev.map(card => {
      if (card.id !== cardId) return card;
      const updatedLines = card.lines.filter(l => l.id !== lineId);
      return { ...card, lines: updatedLines };
    }).filter(card => card.lines.length > 0));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base, minHeight: '40px', borderRadius: '12px', fontSize: '13px', width: '100%',
      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
      '&:hover': { borderColor: '#454CF2' },
    }),
    container: (base) => ({ ...base, width: '100%' }),
    menu: (base) => ({ ...base, fontSize: '12px' }),
    menuList: (base) => ({ ...base, maxHeight: '250px', overflowY: 'auto' }),
    multiValue: (base) => ({ ...base, backgroundColor: '#F0F4F8', borderRadius: '4px', padding: '2px 6px', margin: '2px', maxWidth: '120px' }),
    multiValueLabel: (base) => ({ ...base, color: '#19324C', fontSize: '12px', fontWeight: 500 }),
    valueContainer: (base) => ({ ...base, maxHeight: '35px', height: '40px', overflowY: 'auto', overflowX: 'hidden', flexWrap: 'wrap', alignItems: 'center', paddingTop: '4px', paddingBottom: '4px' }),
    multiValueRemove: (base) => ({ ...base, color: '#19324C', ':hover': { backgroundColor: 'transparent', color: '#ff0000' } })
  };

  const showEmptyState = !contractCode && !contractDetails && !isLoadingDetails;
  const contractStartDate = contractDetails?.contract?.contract_start_date || '';
  const contractEndDate = contractDetails?.contract?.contract_expiry_date || '';

  const handleEditMergedCard = (card) => {
    const originalLines = [];
    card.lines.forEach(line => {
      if (line.isMergedCombined && line.originalRows) {
        line.originalRows.forEach(r => originalLines.push(r));
      } else {
        originalLines.push(line);
      }
    });

    setMergedPopupLines(originalLines);
    setMergedPopupInvoiceType(card.type);
    setEditingCardId(card.id);
    setMergedPopupOpen(true);
  };

  const handleSubmitAutomation = async () => {
    if (isSubmitting) return;

    if (!project) {
      toast.error("Please select a project.");
      return;
    }

    if (!contractCode) {
      toast.error("Please select a contract code.");
      return;
    }

    if (!jobType.length) {
      toast.error("Please select at least one job type.");
      return;
    }

    const missingSchedule = invoiceCards.find(card => !cardSchedules[card.id]);
    if (missingSchedule) {
      toast.error('Please set a time period for all invoice cards before submitting.');
      return;
    }

    if (!invoiceCards.length) {
      toast.error('Please add at least one invoice card before submitting.');
      return;
    }

    setIsSubmitting(true);

    const invoiceLines = [];
    let globalGroupCounter = 1;

    const TYPE_MAP = {
      single_invoice: 'single',
      separate_invoice: 'separate',
      merged_single_invoice: 'merge_single',
      merged_separate_invoice: 'merge_separate',
    };

    const buildPeriod = (schedule) => {
      const formatDate = (d) => (d ? String(d).slice(0, 10) : '');

      const DAY_ABBREV = {
        Sunday: 'Sun',
        Monday: 'Mon',
        Tuesday: 'Tue',
        Wednesday: 'Wed',
        Thursday: 'Thu',
        Friday: 'Fri',
        Saturday: 'Sat',
      };

      if (schedule.periodType === 'weekly') {
        return {
          period_type: 'weekly',
          week_once: schedule.weeklyInterval,
          week_days: DAY_ABBREV[schedule.weeklyDay] || schedule.weeklyDay,
          // week_start_date: formatDate(schedule.triggerStartDate),
          // week_end_date: formatDate(schedule.triggerEndDate),
        };
      }

      return {
        period_type: 'monthly',
        month_date: schedule.monthlyDay,
        month_period: Number(schedule.monthlyInterval),
        // month_start_date: formatDate(schedule.triggerStartDate),
        // month_end_date: formatDate(schedule.triggerEndDate),
      };
    };

    for (const card of invoiceCards) {
      const schedule = cardSchedules[card.id];
      const period = buildPeriod(schedule);
      const apiType = TYPE_MAP[card.type];

      if (card.type === 'single_invoice') {
        const groupNo = globalGroupCounter++;   // one group per card
        for (const line of card.lines) {
          invoiceLines.push({
            automation_line_id: line.automation_line_id ?? null,
            invoice_type: apiType,
            job_type_id: line.job_type_id,
            contract_charge_sales_line_id: line.id,
            invoice_group_no: groupNo,
            sap_id: line.sap_id ?? null,
            sap_code: null,
            period,
            billing_nature: cardBillingNature[card.id] || null,
            remarks: cardRemarks[card.id] || null,
          });
        }
      } else if (card.type === 'separate_invoice') {
        for (const line of card.lines) {
          const lineBillingNature = typeof cardBillingNature[card.id] === 'object'
            ? cardBillingNature[card.id]?.[line.id] || null
            : cardBillingNature[card.id] || null;

          const lineRemarks = typeof cardRemarks[card.id] === 'object'
            ? cardRemarks[card.id]?.[line.id] || null
            : cardRemarks[card.id] || null;

          invoiceLines.push({
            automation_line_id: line.automation_line_id ?? null,
            invoice_type: apiType,
            job_type_id: line.job_type_id,
            contract_charge_sales_line_id: line.id,
            invoice_group_no: null,
            sap_id: line.sap_id ?? null,
            sap_code: null,
            period,
            billing_nature: lineBillingNature,
            remarks: lineRemarks,
          });
        }
      } else {
        const cardInvoiceGroupNo = globalGroupCounter++;
        let lineGroupCounter = 1;

        for (const line of card.lines) {
          const groupKey = line.line_group_no ?? line.id;

          // merged_separate reads per-group; merged_single reads flat
          const bn = card.type === 'merged_separate_invoice'
            ? (typeof cardBillingNature[card.id] === 'object' ? cardBillingNature[card.id]?.[groupKey] || null : null)
            : cardBillingNature[card.id] || null;

          const rm = card.type === 'merged_separate_invoice'
            ? (typeof cardRemarks[card.id] === 'object' ? cardRemarks[card.id]?.[groupKey] || null : null)
            : cardRemarks[card.id] || null;

          if (line.isMergedCombined && line.originalRows) {
            // All originalRows share the same line_group_no (they were combined)
            const lgn = lineGroupCounter++;

            for (const origRow of line.originalRows) {
              invoiceLines.push({
                automation_line_id: origRow.automation_line_id ?? null, // each origRow's own id
                invoice_type: apiType,
                job_type_id: origRow.job_type_id,
                contract_charge_sales_line_id: origRow.id,
                invoice_group_no: cardInvoiceGroupNo,
                line_group_no: lgn,
                sap_id: origRow.sap_id ?? null,
                sap_code: line.sap_code,
                period,
                billing_nature: bn,
                remarks: rm,
              });
            }

          } else {
            // Standalone line — gets its own unique line_group_no
            invoiceLines.push({
              automation_line_id: line.automation_line_id ?? null,
              invoice_type: apiType,
              job_type_id: line.job_type_id,
              contract_charge_sales_line_id: line.id,
              invoice_group_no: cardInvoiceGroupNo,
              line_group_no: lineGroupCounter++,
              sap_id: line.sap_id ?? null,
              sap_code: line.sap_code,
              period,
              billing_nature: bn,
              remarks: rm,
            });
          }
        }
      }
    }

    const payload = {
      contract_id: contractCode.value,
      project_id: contractDetails.contract.project_id,
      invoice_lines: invoiceLines,
    };

    try {
      let res;
      if (isEdit) {
        const updatePayload = {
          project_id: project.value,
          invoice_lines: invoiceLines,
          delete_line_ids: deleteLineIds,
        };
        res = await axiosInstance.post(`/automation/update/${editId}`, updatePayload);
      } else {
        const createPayload = {
          contract_id: contractCode.value,
          project_id: project.value,
          invoice_lines: invoiceLines,
        };
        res = await axiosInstance.post('/automation/save', createPayload);
      }

      if (res.data?.success) {
        toast.success(isEdit ? 'Billing automation updated successfully!' : 'Billing automation saved successfully!');
        setTimeout(() => navigate('/billingAutomation'), 1000);
      } else {
        toast.error(res.data?.message || 'Failed to save billing automation.');
        setIsSubmitting(false);
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || 'Something went wrong.';
      toast.error(msg);
      setIsSubmitting(false);
    }
  };

  const handleRemoveJobType = (jobTypeId) => {
    const newSelected = jobType.filter(j => j.value !== jobTypeId);
    setJobType(newSelected);
    if (newSelected.length === 0) setInvoiceType('');
    setCheckedLines(prev => {
      const updated = { ...prev };
      delete updated[jobTypeId];
      return updated;
    });

    fetchContractDetails(newSelected);
  };

  return (
    <>
      <BillingAutomationHeader />

      <div className="common-cost-creation-header">
        <div className="common-cost-creation-header-left">
          <div className="common-cost-back-btn" onClick={() => navigate(-1)}>
            <img src={back_arrow} alt="Back Arrow" />
          </div>
          <p className="new_job">{isEdit ? 'Edit Billing Automation' : 'New Billing Automation'}</p>
        </div>
        <div className="common-cost-creation-header-right">
          <button className="cancel_btn" onClick={() => navigate(-1)}>Cancel</button>
          <button
            className="submit_btn"
            onClick={handleSubmitAutomation}
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
          >
            {isSubmitting
              ? (isEdit ? 'Updating...' : 'Submitting...')
              : (isEdit ? 'Update' : 'Submit')
            }
          </button>
        </div>
      </div>

      <div className="billing-automation-creation-automation-details">
        <h2 className="billing-automation-creation-section-title">Automation details</h2>

        <div className="billing-automation-creation-top-row">

          {/* Project */}
          <div className="billing-automation-creation-field-group">
            <label className="billing-automation-creation-label">
              Project <span style={{ color: 'red' }}>*</span>
            </label>

            <div className="billing-automation-creation-select-wrapper">
              <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadProjectOptions}
                value={project}
                onChange={(selected) => {
                  setProject(selected);
                  setContractCode(null);
                  setJobType([]);
                  setContractDetails(null);
                  setInvoiceType('');
                  setRemovedLineIds(new Set());
                  setCheckedLines({});
                  setInvoiceCards([]);
                  setDeleteLineIds([]);
                }}
                placeholder="Select Project"
                isClearable
                styles={customSelectStyles}
              />
            </div>
          </div>

          {/* Contract Code */}
          <div className="billing-automation-creation-field-group">
            <label className="billing-automation-creation-label">
              Contract Code <span style={{ color: 'red' }}>*</span>
            </label>
            <div className="billing-automation-creation-select-wrapper">
              <AsyncSelect
                key={project?.value}
                cacheOptions defaultOptions loadOptions={loadContractCodeOptions}
                value={contractCode}
                onChange={(selected) => {
                  setContractCode(selected);
                  setJobType([]);
                  setContractDetails(null);
                  setRemovedLineIds(new Set());
                  setCheckedLines({});
                  setInvoiceType('');
                  setInvoiceCards([]);
                  setDeleteLineIds([]);
                  setJobTypeOptions([]);
                }}
                isDisabled={!project}
                placeholder={
                  project
                    ? "Select Contract Code"
                    : "Select Project First"
                }
                isClearable
                className="billing-automation-async-select" styles={customSelectStyles}
              />
            </div>
          </div>

          {/* Job Type */}
          <div className="billing-automation-creation-field-group" ref={jobDropdownRef}>
            <label className="billing-automation-creation-label">
              Job Type <span style={{ color: 'red' }}>*</span>
            </label>
            <div className="custom-multiselect">
              <div
                className={`jobs-type-filter-dropdown ${!contractCode ? 'disabled' : ''}`}
                onClick={toggleJobDropdown}
                style={{ height: '40px' }}
              >
                {jobType.length > 0
                  ? jobType.length === 1 ? jobType[0].label : `${jobType.length} job types selected`
                  : contractCode ? 'Select Jobs' : 'Select Contract First'}
                <span className="dropdown-arrow">▼</span>
              </div>
              {isJobDropdownOpen && contractCode && (
                <div className="multiselect-options">
                  {jobTypeOptions.map(job => {
                    const isSelected = jobType.some(j => j.value === job.value);
                    return (
                      <label key={job.value} className="multiselect-option">
                        <input type="checkbox" checked={isSelected} onChange={() => handleJobCheckboxChange(job.value)} />
                        {job.label}
                      </label>
                    );
                  })}
                  {jobTypeOptions.length === 0 && (
                    <div style={{ padding: '8px 12px', fontSize: '12px', color: '#9CA3AF' }}>No job types available</div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Type of Sales Invoice */}
          <div className="billing-automation-creation-field-group">
            <label className="billing-automation-creation-label">Type of Sales Invoice</label>
            <div className="billing-automation-creation-select-wrapper">
              <AsyncSelect
                cacheOptions defaultOptions={INVOICE_TYPE_OPTIONS} loadOptions={loadInvoiceTypeOptions}
                value={INVOICE_TYPE_OPTIONS.find(opt => opt.value === invoiceType) || null}
                onChange={(selected) => setInvoiceType(selected?.value || '')}
                placeholder="Select" isClearable
                isDisabled={!project || !contractCode || jobType.length === 0}
                styles={customSelectStyles} className="billing-automation-async-select"
              />
            </div>
          </div>

          {/* Add Invoice Button */}
          {invoiceType && (
            <button className="billing-automation-creation-add-invoice-btn" onClick={handleAddInvoice}>
              <FiPlus size={16} color="#ffffff" />
              Add Invoice
            </button>
          )}
        </div>

        {/* Job Cards */}
        <div className="jobs_popup_jobs_cards">
          <p className="jobs-filter-cards-text">Jobs Cards:</p>
          <div className="job_card_list">
            {jobType.map(job => (
              <div key={job.value} className="job_card_item">
                <span className="job_card_label">{job.label}</span>
                <button className="job_card_remove" onClick={() => handleRemoveJobType(job.value)}>×</button>
              </div>
            ))}
          </div>
        </div>

        {isLoadingDetails && (
          <div style={{ padding: '12px', fontSize: '13px', color: '#6B7280' }}>Loading contract details...</div>
        )}

        {!isLoadingDetails && contractDetails && (
          <div className="billing-automation-creation-info-row">
            <div className="billing-automation-creation-info-cell">
              <span className="billing-automation-creation-info-label">Project</span>
              <span className="billing-automation-creation-info-value">
                {contractDetails.contract.project_code} - {contractDetails.contract.project_name}
              </span>
            </div>
            <div className="billing-automation-creation-info-cell">
              <span className="billing-automation-creation-info-label">Start Date</span>
              <span className="billing-automation-creation-info-value">{contractDetails.contract.contract_start_date}</span>
            </div>
            <div className="billing-automation-creation-info-cell">
              <span className="billing-automation-creation-info-label">End Date</span>
              <span className="billing-automation-creation-info-value">{contractDetails.contract.contract_expiry_date}</span>
            </div>
            <div className="billing-automation-creation-info-cell">
              <span className="billing-automation-creation-info-label">Mail ID</span>
              <div className="billing-automation-creation-info-chips">
                {contractDetails.contract.contract_mail?.split(',').map((mail, i) => (
                  <span key={i} className="billing-automation-info-chip billing-automation-info-chip--mail">{mail.trim()}</span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {showEmptyState && (
        <div className="billing-automation-empty-state">
          <div className="billing-automation-empty-state-icon">
            <TbFileInvoice size={28} color="#9CA3AF" />
          </div>
          <p className="billing-automation-empty-state-title">Start by selecting a project</p>
          <p className="billing-automation-empty-state-desc">
            Choose a <strong>Project</strong> above to load available Contract Codes, and
            then select a Contract Code and configure billing automation.
          </p>
          <div className="billing-automation-empty-state-chips">
            <span className="billing-automation-empty-chip">
              <MdOutlineWorkOutline size={14} style={{ marginRight: '5px', verticalAlign: '-2px' }} />Job Types
            </span>
            <span className="billing-automation-empty-chip">
              <TbReceipt size={14} style={{ marginRight: '5px', verticalAlign: '-2px' }} />Invoice Lines
            </span>
            <span className="billing-automation-empty-chip">
              <TbCalendar size={14} style={{ marginRight: '5px', verticalAlign: '-2px' }} />Scheduling
            </span>
          </div>
        </div>
      )}

      {/* ── Job Type Tables (unchanged) ── */}
      {!isLoadingDetails && contractDetails?.job_types?.map((jt) => {
        const visibleLines = (jt.sales_lines || []).filter(l => !removedLineIds.has(l.id));
        if (visibleLines.length === 0) return null;

        const checkedSet = checkedLines[jt.job_type_id] || new Set();
        const allChecked = visibleLines.length > 0 && visibleLines.every(l => checkedSet.has(l.id));
        const someChecked = visibleLines.some(l => checkedSet.has(l.id));

        return (
          <div key={jt.job_type_id} className="invoice_popup_categories" style={{ marginTop: '10px' }}>
            <div className="invoice_popup_outercategory">
              <div className="invoice_popup_category_header">
                <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span className="category_name">{jt.job_type_name}</span>
                  <img src={delete_icon} style={{ width: '25px', height: '25px', cursor: 'pointer' }} alt="Delete" onClick={() => handleRemoveJobType(jt.job_type_id)} />
                </div>
                <div style={{ display: 'flex', gap: '12px', fontSize: '12px', flexWrap: 'wrap' }}>
                  <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '8px', height: '30px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                    <span style={{ color: 'green', fontWeight: '600' }}>SALES : </span>
                    <span style={{ color: '#000' }}>Net Total : ₹ {jt.sales_total}</span>
                  </div>
                </div>
              </div>

              <div className="invoice_popup_category_subheader">
                <div className="invoice_popup_element_list" style={{ overflowX: 'auto' }}>
                  <div className="table-container">
                    <table className="invoice_table">
                      <thead>
                        <tr>
                          <th rowSpan="2" style={{ width: '50px', minWidth: '50px', textAlign: 'center', padding: '4px' }}>
                            <input
                              type="checkbox"
                              checked={allChecked}
                              ref={el => { if (el) el.indeterminate = someChecked && !allChecked; }}
                              onChange={() => toggleAllLines(jt.job_type_id, visibleLines)}
                              style={{ width: '14px', height: '14px', borderRadius: '2px' }}
                            />
                          </th>
                          <th colSpan="9" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
                        </tr>
                        <tr>
                          {['CHARGE CODE', 'DESCRIPTION', 'PO NUMBER', 'PO DATE', 'REMARKS', 'QUANTITY', 'RATE', 'NET TOTAL'].map((h, i) => (
                            <th key={i} style={{ backgroundColor: '#D9FFE2', ...(i === 6 ? { width: '50px', minWidth: '50px' } : {}) }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {visibleLines.length ? visibleLines.map(line => (
                          <tr key={line.id}>
                            <td style={{ width: '50px', minWidth: '50px', textAlign: 'center', padding: '4px' }}>
                              <input
                                type="checkbox"
                                checked={checkedSet.has(line.id)}
                                onChange={() => toggleLineCheck(jt.job_type_id, line.id)}
                                style={{ width: '14px', height: '14px', borderRadius: '2px' }}
                              />
                            </td>
                            <td style={{ padding: '10px' }}>{line.charge_code}</td>
                            <td>{line.charge_name}</td>
                            <td>{line.po_wo_number || '--'}</td>
                            <td>{line.po_wo_date || '--'}</td>
                            <td>{line.remarks}</td>
                            <td>{line.unit_of_quantity}</td>
                            <td>{line.unit_of_rate}</td>
                            <td>{line.net_total}</td>
                          </tr>
                        )) : (
                          <tr>
                            <td colSpan="8" style={{ textAlign: 'center', padding: '10px', color: '#9CA3AF', fontSize: '13px' }}>
                              No sales lines found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {invoiceCards.map(card => {
        const schedule = cardSchedules[card.id];
        const isPerGroup = card.type === 'separate_invoice'
          || card.type === 'merged_separate_invoice';

        const commonProps = {
          card,
          schedule,
          onDelete: () => handleDeleteCard(card.id),
          onSetPeriod: () => setPeriodPopupCardId(card.id),
          onEdit: () => handleEditMergedCard(card),
          onDeleteLine:
            card.type === 'single_invoice' || card.type === 'separate_invoice'
              ? (lineId) => handleDeleteCardLine(card.id, lineId)
              : null,
          billingNature: cardBillingNature[card.id] || (isPerGroup ? {} : ''),
          onBillingNatureChange: isPerGroup
            ? (groupKey, val) => setCardBillingNature(prev => ({
              ...prev,
              [card.id]: { ...(prev[card.id] || {}), [groupKey]: val }
            }))
            : (val) => setCardBillingNature(prev => ({ ...prev, [card.id]: val })),
          remarks: cardRemarks[card.id] || (isPerGroup ? {} : ''),
          onRemarksChange: isPerGroup
            ? (groupKey, val) => setCardRemarks(prev => ({
              ...prev,
              [card.id]: { ...(prev[card.id] || {}), [groupKey]: val }
            }))
            : (val) => setCardRemarks(prev => ({ ...prev, [card.id]: val })),
        };

        if (card.type === 'single_invoice') return <SingleInvoiceCard key={card.id} {...commonProps} />;
        if (card.type === 'separate_invoice') return <SeparateInvoiceCard key={card.id} {...commonProps} />;
        if (card.type === 'merged_single_invoice') return <MergedSingleInvoiceCard key={card.id} {...commonProps} />;
        if (card.type === 'merged_separate_invoice') return <MergedSeparateInvoiceCard key={card.id} {...commonProps} />;
        return null;
      })}

      {periodPopupCardId && (
        <PeriodPopup
          contractStartDate={contractStartDate}
          contractEndDate={contractEndDate}
          schedule={cardSchedules[periodPopupCardId]}
          onClose={() => setPeriodPopupCardId(null)}
          onSave={handleSavePeriod}
        />
      )}

      <BillingAutomationMergedCharges
        isOpen={mergedPopupOpen}
        onClose={() => {
          setMergedPopupOpen(false);
          setMergedPopupLines([]);
          setMergedPopupInvoiceType('');
          setEditingCardId(null);
        }}
        onComplete={handleMergedComplete}
        selectedLines={mergedPopupLines}
        invoiceType={mergedPopupInvoiceType}
        existingLines={editingCardId
          ? invoiceCards.find(c => c.id === editingCardId)?.lines
          : undefined}
      />

      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default BillingAutomationCreation;